import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  error: null,
  data: [],
  oneData: null,
};

export const visitSlice = createSlice({
  name: 'visit',
  initialState,
  reducers: {
    getVisits: (state) => {
      state.loading = true;
    },
    addVisit: (state) => {
      state.loading = true;
    },
    updateVisit: (state) => {
      state.loading = true;
    },
    removeVisit: (state) => {
      state.loading = true;
    },
    getOneVisit: (state) => {
      state.loading = true;
    },
    successVisit: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    successOneVisit: (state, action) => {
      state.loading = false;
      state.oneData = action.payload;
    },
    failedVisit: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  getVisits,
  addVisit,
  updateVisit,
  removeVisit,
  getOneVisit,
  successVisit,
  successOneVisit,
  failedVisit,
} = visitSlice.actions;

export default visitSlice.reducer;
